export default "__VITE_ASSET__DRo$a_DE__"